import { render, staticRenderFns } from "./StatsRestrictedSoonAccountsModal.vue?vue&type=template&id=16b454d3&"
import script from "./StatsRestrictedSoonAccountsModal.vue?vue&type=script&lang=js&"
export * from "./StatsRestrictedSoonAccountsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports